import { AfterViewChecked, AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MDBModalService, ToastService, MDBModalRef } from 'ng-uikit-pro-standard';
import {
  CartData,
  CartSummary,
  EffectNoficationType,
  NotificationType,
  PaypalPage,
} from 'src/app/shared-core/models/cart-data.model';
import { CartService } from 'src/app/shared-core/services/cart.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaypalService } from 'src/app/shared-core/services/paypal.service';
import { AuthService } from 'src/app/shared-core/services/auth.service';
import { LoginComponent } from 'src/app/account/login/login.component';
import { touchFormControls } from 'src/app/shared-core/services/validation.service';
import { Klarna } from 'src/app/shared-core/typings/klarna.model';
import { CartParserService } from '../../shared-core/services/cart-parser.service';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, AfterViewInit, AfterViewChecked {
  Number = Number;
  IsWaiting: boolean;
  modalRef: MDBModalRef;
  promoCodeForm: FormGroup;
  model: CartSummary;
  canPayPal: boolean;
  payPalTooltip: string = '';
  isUser: boolean = false;

  @ViewChild('loginModal') loginModal: LoginComponent;

  get hasUnappliedCoupon(): boolean {
    if (!this.promoCodeForm) {
      return false;
    }

    return Boolean(this.promoCodeForm.get('promoCode').value);
  }


  constructor(
    private service: CartService,
    private payPalService: PaypalService,
    private toaster: ToastService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cartParser: CartParserService,
    private _modalService: MDBModalService
  ) { }

  ngOnInit(): void {
    window.klarnaExpressButtonAsyncCallback = this.klarnaExpressButtonAsyncCallback.bind(this);
    window.Klarna.ExpressButton.refreshButtons();

    this.promoCodeForm = this.formBuilder.group({
      promoCode: ['', [Validators.required]],
    });
    this.service.ModelSubject.subscribe((model) => {
      this.isUser = model?.IsUser;
      this.model = model.CartSummary;
      this.canPayPal = this.getCanPaypal();

      this.payPalTooltip = '';
      if (this.model.GrandTotal === 0) {
        this.payPalTooltip = 'No items in the cart';
      }
      // return this.model.Subtotal > 0 && this.model.Subtotal <= 10000 && !this.getShippingRejected();
      if (this.model.GrandTotal > 10000) {
        this.payPalTooltip = 'Total cart amount is more than $10,000, so we can not use PayPal. ';
      }

      this.displayPromotionNotifications(model);
    });

    this.service.isLoadingSubject.subscribe((waiting) => {
      this.IsWaiting = waiting;
    });
    this.payPalService.Page = PaypalPage.Cart;
  }

  public ngAfterViewInit(): void {
    this.updateKlarnaCreditBadge();
  }

  public klarnaExpressButtonAsyncCallback() {
    const cartService = this.service;
    window.Klarna.ExpressButton.on('user-authenticated', function (callbackData: Klarna.ExpressButton.CallbackData) {
      cartService.klarnaExpress(callbackData).subscribe(
        () => {
          window.location.href = '/cart/checkout';
        },
        (error) => {
          throw error;
        }
      );
    });
  }

  private updateKlarnaCreditBadge() {
    const klarna = document.getElementById('klarnaCreditBadge');
    (klarna as any).dataset.purchaseAmount = Math.round(this.model?.GrandTotal * 100);
    try {
      window.Klarna.OnsiteMessaging.refresh();
    } catch (e) {
      // throw silently | seems like this is an issue with widget sometimes not populating window object
      // we can not handle this except to catch it
    }
  }

  loadPaypal() {
    let me = this;
    window.addEventListener('load', function (event) {
      me.payPalService.Page = PaypalPage.Cart;
      // disabled the button until further notice
      //me.payPalService.renderPaypalButton('paypal-checkout');
    });
  }

  private displayPromotionNotifications(model: CartData) {
    if (model.PromoNotifications) {
      model.PromoNotifications.forEach((el) => {
        switch (el.EffectType) {
          case EffectNoficationType.Removed:
            this.toaster.info(`Promotion "${el.RuleName}" is removed`);
            break;
          case EffectNoficationType.Rejected:
            this.toaster.error(el.Props.Body, `Coupon ${el.Coupon} is rejected.`, {
              enableHtml: true,
            });
            break;
          case EffectNoficationType.ShowNotification:
            switch (el.Props.NotificationType) {
              case NotificationType.Error:
                this.toaster.error(el.Props.Body, el.Props.Title);
                break;
              case NotificationType.Offer:
                this.toaster.success(el.Props.Body, el.Props.Title);
                break;
              default:
                this.toaster.info(el.Props.Body, el.Props.Title);
            }
        }
      });
      model.PromoNotifications = null;
    }
  }

  private getPromoCodeDisplay(): number {
    if (this.model.DisplayCoupon) {
      return this.model.Discount;
    }
  }

  private getCanPaypal(): boolean {
    return this.model.Subtotal > 0 && this.model.GrandTotal <= 10000;
  }

  onCheckout() {
    if (this.hasUnappliedCoupon) {
      this.modalRef = this._modalService.show(ModalComponent, {
        data: {
          heading: 'Heads Up! You have an unapplied coupon!',
          content: 'You added a coupon but forgot to hit apply.<br><br>Please make sure to go back and hit apply, or remove the coupon if you don\'t want to use it anymore!'
        },
        class: 'modal-dialog-centered modal-lg'
      })
      return;
    }

    this.service.restoreCheckoutSession().subscribe(
      () => {
        if (this.authService.isloggedin) {
          window.location.href = '/cart/checkout';
        } else {
          this.loginModal.show = 'login';
          return;
        }
      },
      (error) => {
        throw error;
      }
    );
  }

  calculateCoupon(): void {
    touchFormControls(this.promoCodeForm);
    if (!this.promoCodeForm.valid) {
      return;
    }
    this.service.updatePromoCode(this.promoCodeForm.value.promoCode).subscribe((cartData) => {
      this.promoCodeForm.patchValue(
        { promoCode: '' },
        {
          emitEvent: false,
        }
      );
    });
  }

  ngAfterViewChecked(): void { }
}
